module.exports = __webpack_public_path__ + "static/media/welcome-wallet.6f8b13fa.svg";